import { Navigate } from "react-router-dom";

const OldSystem = (props) => {
  return <Navigate to="/" />;
};

export default OldSystem;
